import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Search } from 'lucide-react';

// Pages
import { ProjectsPage } from './pages/ProjectsPage';
import { DashboardPage } from './pages/DashboardPage';
import { PageDetailPage } from './pages/PageDetailPage';

// Layout component
function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-surface-50">
      {/* Header */}
      <header className="bg-white border-b border-surface-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-brand-500 to-brand-700 rounded-lg flex items-center justify-center">
                <Search className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-lg text-surface-900">SEO Audit</span>
            </a>

            <nav className="flex items-center gap-4">
              <a
                href="/"
                className="text-sm font-medium text-surface-600 hover:text-surface-900 transition-colors"
              >
                Projects
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-surface-600 hover:text-surface-900 transition-colors"
              >
                Docs
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-surface-200 bg-white mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <p className="text-sm text-surface-500">
              SEO Audit Tool - Analyze and improve your website's SEO
            </p>
            <p className="text-sm text-surface-400">
              Built with React, TypeScript, and Cloudflare
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {/* Projects list */}
          <Route path="/" element={<ProjectsPage />} />

          {/* Project dashboard */}
          <Route path="/projects/:projectId" element={<DashboardPage />} />

          {/* Page detail */}
          <Route path="/projects/:projectId/pages/:pageId" element={<PageDetailPage />} />

          {/* 404 */}
          <Route
            path="*"
            element={
              <div className="text-center py-12">
                <h1 className="text-2xl font-bold text-surface-900 mb-2">Page Not Found</h1>
                <p className="text-surface-500 mb-6">The page you're looking for doesn't exist.</p>
                <a href="/" className="btn-primary">
                  Go Home
                </a>
              </div>
            }
          />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
